module.exports = __webpack_public_path__ + "static/img/smt_material_20260812.ca2da88e.png";